import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { ArrowUpRight, Check } from "lucide-react";

export default function FeaturedProducts() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/products", { params: { featured: true, limit: 6 } })
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section
      className="py-20 md:py-28 border-b border-white/10"
      data-testid="section-featured-products"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="eyebrow">Featured catalogue</div>
            <h2 className="font-display text-3xl md:text-5xl uppercase mt-3 tracking-tighter">
              Off-the-shelf &amp; built-to-spec.
            </h2>
          </div>
          <Link to="/products" className="btn-secondary" data-testid="featured-products-view-all">
            View full catalogue <ArrowUpRight size={16} />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((p, idx) => (
            <Link
              key={p.id}
              to={`/products/${p.id}`}
              className="industrial-card group overflow-hidden flex flex-col"
              data-testid={`featured-product-${idx}`}
            >
              {p.image_url && (
                <div className="aspect-[4/3] overflow-hidden border-b border-white/10">
                  <img
                    src={fileUrl(p.image_url)}
                    alt={p.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
              )}
              <div className="p-5 flex-1 flex flex-col">
                <div className="flex items-center gap-2">
                  <span className="tag-chip tag-chip-red">{p.category}</span>
                  {p.in_stock && (
                    <span className="tag-chip flex items-center gap-1" style={{ borderColor: "#25d36655", color: "#25d366" }}>
                      <Check size={10} /> In stock
                    </span>
                  )}
                </div>
                <div className="font-display text-base uppercase mt-3 leading-tight">
                  {p.name}
                </div>
                <p className="text-sm text-zinc-400 mt-2 leading-relaxed line-clamp-2 flex-1">
                  {p.short_description}
                </p>
                <div className="mt-3 pt-3 border-t border-white/10 flex items-center justify-between">
                  <span className="font-mono text-xs text-zinc-300">
                    {p.price_text || "On request"}
                  </span>
                  <ArrowUpRight size={14} className="text-zinc-500 group-hover:text-[#e63946]" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
